import React from "react"
import { colours } from "@shared/ui.design-system"
import { BasketIconButton } from "components/ProductCounter/IconButton"
import { useReactiveVar } from "@apollo/client"
import { basketOperationInFlightVar } from "lib/apollo/variables/uxVars"
import { BinIcon } from "components/SVG/BinIcon"

type Props = {
  removeItem: () => void
  disabled?: boolean
}

export const RemoveFromBagButton: React.FC<Props> = ({
  removeItem,
  disabled = false,
}) => {
  const opInFlight = useReactiveVar(basketOperationInFlightVar)
  const removeIcon = <BinIcon color={colours.primary.dark} />

  return (
    <BasketIconButton
      minHeight={2}
      marginTop={0}
      aria-label="Remove product from bag"
      data-testid="basket-remove-icon"
      onClick={removeItem}
      icon={removeIcon}
      isDisabled={disabled || opInFlight}
    />
  )
}
